module.exports = __webpack_public_path__ + "img/creative-tim.dc0324d3.svg";